/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{useLexicalComposerContext as r}from"@lexical/react/LexicalComposerContext";import{useLayoutEffect as t,useEffect as e,useMemo as i,useState as n,useRef as c}from"react";import{CAN_USE_DOM as o}from"lexical";const u=o?t:e;function a(r){return{initialValueFn:()=>r.isEditable(),subscribe:t=>r.registerEditableListener(t)}}function l(){return function(t){const[e]=r(),o=i(()=>t(e),[e,t]),[a,l]=n(()=>o.initialValueFn()),s=c(a);return u(()=>{const{initialValueFn:r,subscribe:t}=o,e=r();return s.current!==e&&(s.current=e,l(e)),t(r=>{s.current=r,l(r)})},[o,t]),a}(a)}export{l as useLexicalEditable};
